exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tip[data-v-f82c71de]{line-height:35px;margin-bottom:10px}\n", ""]);

// exports
